import React from 'react';
import usePrivateMedia from '../../hooks/usePrivateMedia';

export default function PrivateImage({ src, alt, onClick, ...props }) {
  const resolved = usePrivateMedia(src);
  if (resolved === null) return <span role="alert">Unable to access image.</span>;
  if (!resolved) return <span role="status">Loading image…</span>;
  return <img {...props} src={resolved} alt={alt} onClick={onClick} />;
}
